// src/components/partner-loyalty-points/partner-loyalty-points.tsx
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    weight\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  query PartnerLoyaltyPointsQuery($context: ContextInput!) {\n    partnerLoyaltyPoints(context: $context) {\n      description {\n        ...EGDSStylizedTextFragment\n      }\n      shortDescription {\n        ...EGDSStylizedTextFragment\n      }\n      balance {\n        ...EGDSStylizedTextFragment\n      }\n      value {\n        ...EGDSStylizedTextFragment\n      }\n    }\n  }\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
import React2 from "react";
import { gql as gql2, useQuery } from "@apollo/client";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { useBexApi } from "@shared-ui/bex-api-context";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
// src/components/partner-loyalty-points/__private/__fragments/egds-stylized-text.tsx
import React from "react";
import { gql } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var _obj;
// src/components/partner-loyalty-points/__private/__fragments/__private/text-weight-mapper.tsx
var textWeightMapper = (_obj = {}, _define_property(_obj, "BOLD" /* BOLD */, "bold"), _define_property(_obj, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj, "REGULAR" /* REGULAR */, "regular"), _obj);
// src/components/partner-loyalty-points/__private/__fragments/egds-stylized-text.tsx
var fragment = gql(_templateObject());
var EGDSStylizedText = function (param) {
  var _param_data = param.data,
    text = _param_data.text,
    weight = _param_data.weight,
    inline = param.inline,
    theme = param.theme,
    align = param.align;
  var weightProps = weight ? textWeightMapper[weight] : void 0;
  return /* @__PURE__ */React.createElement(EGDSText, {
    weight: weightProps,
    inline: inline,
    theme: theme,
    align: align
  }, text);
};
EGDSStylizedText.fragment = fragment;
EGDSStylizedText.displayName = "EGDSStylizedText";
// src/components/partner-loyalty-points/partner-loyalty-points.tsx
var __Query = gql2(_templateObject1(), EGDSStylizedText.fragment);
var PartnerLoyaltyPoints = function (param) {
  var inputs = param.inputs,
    skipSsr = param.skipSsr,
    inverseTheme = param.inverseTheme;
  var context = useBexApi().context;
  var viewSize = useMediaQueries({
    viewSizes: defaultViewSizes
  });
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        useApq: true
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  if (loading || error || !data) {
    return null;
  }
  var themeProps = inverseTheme ? {
    theme: "inverse"
  } : {};
  return /* @__PURE__ */React2.createElement(EGDSLayoutFlex, {
    wrap: "wrap",
    space: "one",
    justifyContent: "end"
  }, /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, viewSize !== defaultViewSizes.EXTRA_LARGE ? data.partnerLoyaltyPoints.shortDescription && /* @__PURE__ */React2.createElement(EGDSStylizedText, _object_spread({
    data: data.partnerLoyaltyPoints.shortDescription
  }, themeProps)) : data.partnerLoyaltyPoints.description && /* @__PURE__ */React2.createElement(EGDSStylizedText, _object_spread({
    data: data.partnerLoyaltyPoints.description
  }, themeProps))), /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, data.partnerLoyaltyPoints.balance && /* @__PURE__ */React2.createElement(EGDSStylizedText, _object_spread_props(_object_spread({
    data: data.partnerLoyaltyPoints.balance
  }, themeProps), {
    align: "right"
  }))), /* @__PURE__ */React2.createElement(EGDSLayoutFlexItem, null, data.partnerLoyaltyPoints.value && /* @__PURE__ */React2.createElement(EGDSStylizedText, _object_spread_props(_object_spread({
    data: data.partnerLoyaltyPoints.value
  }, themeProps), {
    align: "right"
  }))));
};
PartnerLoyaltyPoints.displayName = "sharedui-PartnerLoyaltyPoints";
export { PartnerLoyaltyPoints };